module.exports = __webpack_public_path__ + "static/bg-33484114ac55664d92ae2e3809a21386.jpg";